import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/app/[locale]/integrations/[slug]/integration.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/node_modules/next/dist/client/link.js");
